import React from "react";
import { Outlet } from "react-router-dom";
import "./MainPage.css";
import Header from "../../layouts/header/Header";
import Sidebar from "../../layouts/sidebar/Sidebar";
interface Props {
  setIsAuthenticated: (auth: boolean) => void;
}

const MainPage: React.FC<Props> = ({ setIsAuthenticated }) => {
  return (
    <div className="main-layout">
      <Header setIsAuthenticated={setIsAuthenticated} />
      <div id="main-content" className="main-body">
        <Sidebar />
        <div className="main-content">
          <Outlet /> {/* Renders route content */}
        </div>
      </div>
    </div>
  );
};

export default MainPage;
